import { render, staticRenderFns } from "./options-dialog.vue?vue&type=template&id=831c20cc"
import script from "./options-dialog.vue?vue&type=script&lang=js"
export * from "./options-dialog.vue?vue&type=script&lang=js"
import style0 from "./options-dialog.vue?vue&type=style&index=0&id=831c20cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports